import React, { useState } from 'react';
import { Button, IconButton, Tooltip, TableCell } from '@material-ui/core';
import List from '@material-ui/icons/List';
import CreateDatasetDialog from './CreateDatasetDialog';

function CreateDatasetButton(props) {
    const [openDialog, setOpenDialog] = useState(false);

    return (
        <>

            {props.form ? <Button className='whitespace-nowrap mx-4' variant='contained' color='secondary' disabled={!props.item || !props.item.id} onClick={e => { setOpenDialog(true); e.preventDefault(); }} startIcon={<List className='hidden sm:flex' />}>
                Create Dataset
            </Button> : <TableCell className='w-auto text-center' padding='none'>
                <Tooltip title='Create Dataset'>
                    <IconButton onClick={e => { setOpenDialog(true); e.preventDefault(); }}><List fontSize='small' /></IconButton>
                </Tooltip>
            </TableCell>}

            {openDialog && (<CreateDatasetDialog measurement={props.item.id} onCancel={() => setOpenDialog(false)} onSave={result => { setOpenDialog(false); }} />)}

        </>
    );
}

export default CreateDatasetButton;
